module.exports = __webpack_public_path__ + "img/9788960512566.de8df640.jpg";